import { render, staticRenderFns } from "./BookingDebts.vue?vue&type=template&id=668ebfb8"
import script from "./BookingDebts.vue?vue&type=script&lang=js"
export * from "./BookingDebts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports